export class AssignSalespersonModel {
    public clientIds: number[];
    public salespersonId: string;
}
